import React from 'react';
import { CTAButton } from './CTAButton';
interface Plan {
  badge: string;
  badgeHighlight?: boolean;
  title: string;
  subtitle: string;
  features: string[];
  image: string;
  price: string;
  href: string;
  highlight?: boolean;
  tagline?: string;
}
const PLANS: Plan[] = [{
  badge: 'PACK EFEMÉRIDES + BONUS',
  title: 'Pack Completo',
  subtitle: 'Todo lo que necesitás para los actos del año',
  features: ['Pack Efemérides Listas completo', 'BONUS – Glosas Listas', 'BONUS – Actos Resueltos', 'BONUS – MegaPack Mundial 2026', 'Acceso inmediato y de por vida'],
  image: 'https://cdn.magicpatterns.com/uploads/jfBxiKrK3jKWq9EvCpTMk4/1587ce00-8460-4766-9e3b-a17f83d1fddd.png',
  price: 'ARS $19.990',
  href: 'https://checkout.aula-mater.online/cart/44801847558189:1'
}, {
  badge: 'EFEMÉRIDES + INCLUSIÓN',
  badgeHighlight: true,
  title: 'El pack más completo',
  subtitle: 'Con esto completás todo el año',
  features: ['Todo lo del Pack Completo', 'BONUS – Glosas Listas', 'BONUS – Actos Resueltos', 'BONUS – MegaPack Mundial 2026', 'MegaPack Inclusión Educativa', 'El mayor ahorro'],
  image: 'https://cdn.magicpatterns.com/uploads/7XWyaGkipauB8WF3Df6TD3/ChatGPT_Image_19_jun_2026,_04_32_00_a.m..png',
  price: 'ARS $27.990',
  href: 'https://checkout.aula-mater.online/cart/66887821852717:1',
  highlight: true,
  tagline: 'MÁS ELEGIDO'
}];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-229">
      <div className="max-w-5xl mx-auto" data-id="element-230">
        <h2 className="text-[20px] font-black mb-2 text-[#F9327E]" data-id="element-231">
          Accedé ahora al Pack Efemérides Listas
        </h2>

        <p className="text-xl md:text-2xl font-medium mb-4 max-w-2xl mx-auto" data-id="element-232">
          Tener todo el material organizado durante el año escolar puede
          ahorrarte muchísimo tiempo y trabajo.
        </p>

        <div className="flex justify-center mb-6" data-id="element-233">
          
        </div>

        <p className="text-2xl md:text-3xl font-black text-white mb-6" data-id="element-234">
          👉 Elegí tu plan
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto text-left" data-id="element-235">
          {PLANS.map(plan => <div key={plan.title} className={`relative flex flex-col rounded-3xl p-6 md:p-8 shadow-2xl ${plan.highlight ? 'bg-[#0e2e1a] border-4 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.4)]' : 'bg-gray-900 border-2 border-gray-800'}`} data-id="element-236">
              {plan.tagline && <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-black text-sm font-black px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-237">
                  ⭐ {plan.tagline}
                </span>}

              <span className={`self-start text-[11px] font-black uppercase tracking-wider px-3 py-1.5 rounded-full mb-4 ${plan.badgeHighlight ? 'bg-[#22c55e] text-black' : 'bg-gray-700 text-gray-200'}`} data-id="element-238">
                {plan.badge}
              </span>

              <h3 className="text-2xl md:text-3xl font-black mb-1" data-id="element-239">
                {plan.title}
              </h3>
              <p className={`text-base font-medium mb-5 ${plan.highlight ? 'text-[#86efac]' : 'text-gray-400'}`} data-id="element-240">
                {plan.subtitle}
              </p>

              <ul className="space-y-2.5 mb-6 flex-1" data-id="element-241">
                {plan.features.map(feature => <li key={feature} className="flex items-start" data-id="element-242">
                    <span className="text-[#22c55e] font-black mr-2 flex-shrink-0" data-id="element-243">
                      ✔
                    </span>
                    <span className="text-base md:text-lg font-medium text-gray-100" data-id="element-244">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <div className="flex justify-center mb-4" data-id="element-245">
                <img src={plan.image} alt={plan.title} className="w-full max-w-[260px] h-auto object-contain drop-shadow-xl rounded-xl" data-id="element-246" />
              </div>

              <div className="mb-5" data-id="element-247">
                <p className="text-gray-400 text-xs uppercase tracking-widest font-bold mb-1" data-id="element-248">
                  Precio único
                </p>
                <p className="text-4xl md:text-5xl font-black text-white" data-id="element-249">
                  {plan.price}
                </p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-250">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <CTAButton href={plan.href} className="w-full text-lg md:text-xl py-5 flex items-center justify-center gap-3" data-id="element-251">
                <img src="https://cdn.magicpatterns.com/uploads/1zsZUAsENUbyjUUgU5zi4q/728fb7bc-1af5-4646-a10e-52053b14ff22.png" alt="Shopify" className="w-8 h-8 flex-shrink-0 object-contain brightness-0 invert" data-id="element-252" />
                LO QUIERO
              </CTAButton>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto mt-8 flex flex-col items-center" data-id="element-253">
          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20Pack%20Efemerides%20Listas%2C%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="w-full text-xl md:text-2xl py-6 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-254">
            <svg className="w-7 h-7 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-255">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-256" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <a href="https://drive.google.com/file/d/1ieGy6YZfhwy2Teeg1DPEWld1lEkTEswM/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block text-lg md:text-xl font-bold text-yellow-400 hover:text-yellow-300 underline underline-offset-4 mb-6 transition-colors" data-id="element-257">
            📄 Ver muestra gratis
          </a>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm md:text-base font-bold text-gray-300" data-id="element-258">
            <span className="flex items-center" data-id="element-259">
              <span className="text-green-500 mr-2" data-id="element-260">✔</span> para 1° a 6° grado
            </span>
            <span className="flex items-center" data-id="element-261">
              <span className="text-green-500 mr-2" data-id="element-262">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-263">
              <span className="text-green-500 mr-2" data-id="element-264">✔</span> descarga digital
            </span>
            <span className="flex items-center" data-id="element-265">
              <span className="text-green-500 mr-2" data-id="element-266">✔</span> material para todo
              el ciclo lectivo
            </span>
          </div>
        </div>
      </div>
    </section>;
}